import request from './request';

const paymentApis = {
    notifyPaymentEmail: `/payment/notify-payment-email`
};

export async function notifyPaymentEmailApi({ merchantId }) {
    const response = await request.post(paymentApis.notifyPaymentEmail, { merchantId });
    return response.data;
}
